// extracted by mini-css-extract-plugin
export default {"LanguageSelect":"LanguageSelect__Cah9e"};